import React from 'react';
import { useTranslation } from '@hooks/useTranslation';

interface BudgetTabNavigationProps {
  budgetTabType: 'active' | 'past';
  setBudgetTabType: (type: 'active' | 'past') => void;
  pastBudgetsCount: number;
}

export const BudgetTabNavigation: React.FC<BudgetTabNavigationProps> = ({
  budgetTabType,
  setBudgetTabType,
  pastBudgetsCount,
}) => {
  const tTaskDetail = useTranslation('taskDetail');

  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8">
        <button
          type="button"
          onClick={() => setBudgetTabType('active')}
          className={`py-2 px-1 border-b-2 font-medium text-sm ${
            budgetTabType === 'active'
              ? 'border-blue-500 text-blue-600'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          }`}>
          {tTaskDetail.budget.tabActive}
        </button>
        <button
          type="button"
          onClick={() => setBudgetTabType('past')}
          className={`py-2 px-1 border-b-2 font-medium text-sm ${
            budgetTabType === 'past'
              ? 'border-orange-500 text-orange-600'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          }`}>
          {tTaskDetail.budget.tabPast}
          <span className="ml-1 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
            {pastBudgetsCount}
          </span>
        </button>
      </nav>
    </div>
  );
};
